
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46","height":"46","viewBox":"0 0 46 46"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 135577","transform":"translate(.386)"}},[_c('rect',{attrs:{"data-name":"Rectangle 111408","width":"46","height":"46","rx":"12","transform":"translate(-.386)","fill":"#28c76f","opacity":".1"}}),_c('g',{attrs:{"data-name":"Group 135573"}},[_c('g',{attrs:{"fill":"none","stroke":"#28c76f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/clipboard-text"}},[_c('path',{attrs:{"d":"M18.333 24.233H26.5","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M18.333 28.9h5.11","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M20.666 17h4.667c2.333 0 2.333-1.167 2.333-2.333 0-2.334-1.166-2.334-2.333-2.334h-4.667c-1.166 0-2.333 0-2.333 2.333S19.5 17 20.666 17z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M27.667 14.69c3.885.21 5.833 1.645 5.833 6.977v7c0 4.667-1.167 7-7 7h-7c-5.833 0-7-2.333-7-7v-7c0-5.32 1.948-6.767 5.833-6.977"}})])])])])
          )
        }
      }
    